export const licenseKey = '';